import React from 'react';
import PropTypes from 'prop-types';
import { Header, Sup } from 'Components';
import { arrayMove } from 'helpers/array-helpers';
import { handleColumnSave } from 'helpers/column-save';
import PowerTableTr from '../PowerTableTr/PowerTableTr';
import './PowerTableCenter.css';

class PowerTableCenter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dragIndexFrom: undefined,
      dragIndexTo: undefined,
      newKeys: props.keys,
    };

    this.onDragStart = this.onDragStart.bind(this);
    this.onDragOver = this.onDragOver.bind(this);
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  onDragStart(i) {
    this.setState({
      dragIndexFrom: i,
      dragIndexTo: i,
    });
  }

  onDragOver(i) {
    if (i !== this.state.dragIndexTo) {
      this.setState({ dragIndexTo: i });
    }
  }

  onDragEnd() {
    this.setState(prevState => ({
      dragIndexFrom: undefined,
      dragIndexTo: undefined,
      newKeys: arrayMove(this.props.keys, prevState.dragIndexFrom, prevState.dragIndexTo),
    }), () => handleColumnSave(this.state.newKeys, this.props.viewCode, this.props.setAppState));
  }

  render() {
    return (
      <div className="power-table-center">
        <div style={{ paddingLeft: `${this.props.leftOffset}px` }}>
          <table style={{ width: '100%' }}>
            <thead>
              <tr onDrop={this.onDrop}>
                { this.props.keys.map((key, i) => (
                  <Header
                    key={key}
                    keyVal={key}
                    sort={this.props.sort}
                    // For manual sort
                    handleSortClick={this.props.handleSortClick}
                    hasManualSort={this.props.hasManualSort}

                    // For auto sort
                    code={this.props.code}
                    paddingRight={this.props.keys.length === i - 1
                      ? '0.5rem'
                      : `calc(0.5rem + ${this.props.rightOffset}px)`
                    }
                    sortable={key !== 'CompletedSamples'}
                    onDragStart={() => this.onDragStart(i)}
                    onDragOver={() => this.onDragOver(i)}
                    onDragEnd={this.onDragEnd}
                    isHoverActive={this.state.dragIndexTo === i}
                    isDraggable
                    index={i}
                  >
                    {String(this.props.keyPairs[key]).includes('&sup') ?
                      <Sup>{this.props.keyPairs[key]}</Sup> : this.props.keyPairs[key]}
                  </Header>
                ))}
              </tr>
            </thead>
            <tbody>
              {this.props.data.map((row, i) => (
                <PowerTableTr
                  row={row}
                  key={i}
                  keys={this.props.keys}
                  keyPairs={this.props.keyPairs}
                  onClick={() => this.props.setPageState({
                    powerTableIndex: this.props.powerTableIndex === i ? null : i,
                    powerTableViewCode: this.props.viewCode,
                  })}
                />
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

PowerTableCenter.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
  keys: PropTypes.arrayOf(PropTypes.string),
  keyPairs: PropTypes.shape({}),
  leftOffset: PropTypes.number,
  rightOffset: PropTypes.number,
  sort: PropTypes.string,
  code: PropTypes.string,
  setPageState: PropTypes.func,
  powerTableIndex: PropTypes.number,
  viewCode: PropTypes.string,
  setAppState: PropTypes.func,
  handleSortClick: PropTypes.func,
  hasManualSort: PropTypes.bool,
};

PowerTableCenter.defaultProps = {
  handleSortClick: ()  => null,
  hasManualSort: false,
}

export default PowerTableCenter;



// WEBPACK FOOTER //
// ./src/components/PowerTable/PowerTableCenter/PowerTableCenter.jsx